<template>
  <svg fill="none" height="18" viewBox="0 0 18 18" width="18">
    <path
      d="M17 3L6 14L1 9"
      stroke="black"
      stroke-linecap="round"
      stroke-linejoin="round"
      stroke-width="2"
    />
  </svg>
</template>

<script>
  export default {
    name: 'CheckIcon',
  };
</script>
